// Import project components
import {FeatureSlider} from "./cmsmodules/usp";
import {ImagesMultiColumn} from "./cmsmodules/imagesmulticolumn";
import {SliderResponsive} from "./cmsmodules/sliderresponsive";
import {SliderBrands} from "./cmsmodules/sliderbrands";
import {SliderProducts} from "./cmsmodules/sliderproducts";
import {TextModuleToggler} from "./cmsmodules/textModuleToggler";

new FeatureSlider();
new ImagesMultiColumn();
new SliderResponsive();
new SliderBrands();
new SliderProducts();
new TextModuleToggler();
